module.exports = __webpack_public_path__ + "static/media/29BDOS4.f054d5a5.jpg";